export default {
  
  specialKeys: [
    'Windows', 'Command', 'Menu', 'Esc', 'Escape',
    'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12',
    'Tab', 'Caps lock', 'Shift', 'Ctrl', 'Control', 'Fn', 'Alt', 'Spacebar', ' ', 'ContextMenu', 'Clear',
    'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', 'Prt Scrn', 'Scroll Lock', 'Pause', 'Break',
    'Insert', 'Home', 'Page up', 'Page down', 'End', 'Num Lock',
    '~', '`', '!', '@', '#', '£', '€', '$', '¢', '¥', '§', '%', '°', '^', '&', '*', '(', ')', '-', '_', '+', '=',
    '{', '}', '[', ']', '|', '\\', '/', ':', ';', '"', '\'', '>', ',', '?',
  ],

  numberKeys: [
    '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.',
  ],
  
  alphabetKeys: [
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 
    'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 
    's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
  ],

  isCharEqualKey(char, key) {
    const isEqual = key.toLowerCase() === char.toLowerCase()
      || key.replace(/\s/g, '').toLowerCase() === char.toLowerCase();

    return isEqual;
  },

  isCharEqualUndo(char) {
    const isEqual = this.isCharEqualKey(char, 'Back Space')
      || this.isCharEqualKey(char, 'Delete')
      || this.isCharEqualKey(char, '<');

    return isEqual;
  },

  setInput(input, char, state) {
    let newValue = '';
    const isSpecialKey = this.specialKeys.find(key => this.isCharEqualKey(char, key));
    if (isSpecialKey) return;
    if (!input.item[input.property]) {
      newValue = char;
    } else {
      newValue = input.item[input.property] + char;
    }
    
    // deleting
    if (this.isCharEqualUndo(char)) {
      newValue = input.item[input.property] ? (`${input.item[input.property]}`).slice(0, -1) : null;
    }
    
    // number only, 
    const isNumberKey = this.numberKeys.find(key => this.isCharEqualKey(char, key)) 
                        && (input.usingDecimal || char !== '.');
    const isAlphabetKey = this.alphabetKeys.find(key => this.isCharEqualKey(char, key));
    const isKeyValid = isNumberKey || (input.alphabetable && isAlphabetKey);
    // key neither number or allowed alphabet
    if (!isKeyValid && !this.isCharEqualUndo(char)) return;
    // make sure all alphabet is upper
    if(isAlphabetKey) {
      newValue = newValue.toUpperCase();
    }
    // no 2 dot in number
    if (newValue && ((newValue.split('.').length - 1) >= 2)) return;
    // no third decimal
    if(newValue) {
      const numberParts = newValue.split('.');
      if (numberParts.length == 2 && numberParts[1].length > 2) return;
    }
    if (newValue 
        && newValue.length > input.maxLength) 
        return;
    input.item[input.property] = newValue;
  },
  
  refreshCursor(state, blurTimeout) {
    clearTimeout(blurTimeout);
    setTimeout(() => {
      const cs = getComputedStyle(state.currentInputPad.element);
      const paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
      const borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
      const elementWidth = state.currentInputPad.element.offsetWidth - paddingX - borderX;
      state.textLength = (elementWidth + state.textLengthMeasurer.clientWidth) / 2 + 2;
    }, 0);
  }
};
